import React from 'react'
import aboutHero from './pics/about-hero.png'
import aboutMobile from './pics/about-hero-mobile.jpg'
import { animated, useSpring } from 'react-spring';
import { useTranslation } from 'react-i18next';
import { useMobileBreakpoint } from '../breakpoints';
import Fade from 'react-reveal/Fade';
import { Wrapper, Content, Fingerprint, FingerprintRight, ContentWrapper} from './index.styled'
import Typography from '../Typography'

export const AboutHero = () => {
  const isMobile = useMobileBreakpoint();
  const { t } = useTranslation();
  const isIE = /*@cc_on!@*/false || !!document.documentMode;

  const leftProps = useSpring({
    delay: 500,
    from: {
      transform: 'translate3d(-200px, 0px, 0px)',
      opacity: 0,
    },
    to: {
      transform: 'translate3d(0px, 0px, 0px)',
      opacity: 1,
    }
  });

  const rightProps = useSpring({
    delay: 500,
    from: {
      transform: 'translate3d(200px, 0px, 0px) rotate(180deg)',
      opacity: 0,
    },
    to: {
      transform: 'translate3d(0px, 0px, 0px) rotate(180deg)',
      opacity: 1,
    }
  });

  return (
  <>
    <Wrapper>
      {
        isMobile ? (
          <img src={aboutMobile} alt="" role="presentation" />
        ):
        (
          <>
            <Fingerprint>
              <animated.img src={aboutHero} alt="" role="presentation" style={leftProps} />
            </Fingerprint>
            <FingerprintRight>
              <animated.img src={aboutHero} alt="" role="presentation" style={rightProps} />
            </FingerprintRight>
          </>
        )
      }
    </Wrapper>
    <ContentWrapper>
      <Fade up>
        <Content ie={isIE.toString()}>
          <Typography.Heading3>{t('AboutUsPage.Hero.title')}</Typography.Heading3>
          <Typography.Body>{t('AboutUsPage.Hero.description')}</Typography.Body>
        </Content>
      </Fade>
    </ContentWrapper>
  </>
);
}